var React = require('react');

function IconArrowRightInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},[React.createElement("circle",{"cx":"12","cy":"12.5","r":"12","fill":"#3098F3","key":0}),React.createElement("path",{"d":"M10 8L14.5 12.5L10 17","stroke":"white","strokeWidth":"2","strokeMiterlimit":"10","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",null,React.createElement("rect",{"y":"0.5","width":"24","height":"24","fill":"white"})))]);
}

IconArrowRightInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = IconArrowRightInline;

IconArrowRightInline.default = IconArrowRightInline;
